const parseDate = (value) => {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null
    const date = new Date(`${value}T00:00:00.000Z`)
    return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === value ? date : null
}

const MONTHS = {
    en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    fr: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juill.', 'août', 'sept.', 'oct.', 'nov.', 'déc.']
}

export const formatDeliveryDates = (range, formatDate, locale = 'en') => {
    const start = parseDate(range?.startDate)
    const end = parseDate(range?.endDate)
    if (!start || !end || start > end) return null
    // These are calendar dates, not instants in the shopper's browser time zone.
    const options = {day: 'numeric', timeZone: 'UTC'}
    try {
        const french = locale.toLowerCase().startsWith('fr')
        const months = MONTHS[french ? 'fr' : 'en']
        const sameMonth = start.getUTCFullYear() === end.getUTCFullYear() && start.getUTCMonth() === end.getUTCMonth()
        const startDay = formatDate(start, options)
        const endDay = formatDate(end, options)
        const startMonth = months[start.getUTCMonth()]
        const endMonth = months[end.getUTCMonth()]
        return french
            ? {startDate: sameMonth ? startDay : `${startDay} ${startMonth}`, endDate: `${endDay} ${endMonth}`}
            : {startDate: `${startMonth} ${startDay}`, endDate: sameMonth ? endDay : `${endMonth} ${endDay}`}
    } catch (error) {
        return null
    }
}
